import { memo } from 'react';

import { merge } from '@/components';
import { Flex, TruncatedText } from '@/components/core';
import { DocumentIcon, ImageIcon, PDFIcon, SaveIcon } from '@/components/icons';
import { useAgentRunTree } from '@/hooks';
import { DivProps } from '@/utils';

export type AgentRunDocumentCardProps = DivProps & {
  agentId: string;
  runId: string;
};

const IAgentRunDocumentCard = ({ agentId, runId, className, ...rest }: AgentRunDocumentCardProps) => {
  const { taskDocument } = useAgentRunTree({ agentId, runId });

  if (!taskDocument) {
    return (
      <Flex className={merge('items-center', className)} {...rest}>
        <Flex className="gap-sm items-center justify-center p-2">
          <DocumentIcon className="absolute size-[1.6875rem]" />
          <SaveIcon className="!size-[0.625rem] translate-y-[4px]" />
        </Flex>
        <div className="ml-[9px] h-3 w-48 animate-pulse rounded-lg bg-gray-200" />
      </Flex>
    );
  }

  return (
    <Flex className={merge('gap-sm items-center', className)} {...rest}>
      {taskDocument.contentType === 'application/pdf' ? (
        <PDFIcon className="min-h-[1.6875rem] min-w-[1.6875rem]" />
      ) : (
        <ImageIcon className="min-h-[1.6875rem] min-w-[1.6875rem]" />
      )}
      <TruncatedText className="text-gray-800">{taskDocument.name}</TruncatedText>
    </Flex>
  );
};

export const AgentRunDocumentCard = memo(IAgentRunDocumentCard) as typeof IAgentRunDocumentCard;
